import { DispatchToCustomer, Constants } from '../../../../../core';
import { DataTable } from '../../data-table.interface';
const validateState = (state): string => {
  let stateComplete = '';
  Constants.Order.DISPATCH_STATUS.forEach(element => {
    if (state === element.value) {
      stateComplete = element.text;
    }
  });
  return stateComplete;
};

const iconsOfActionsList = [
  {
    icon: 'trash',
    tooltip: 'Retirar despacho(s)'
  }
];

const dispatchSelected: DataTable = {
  searchText: '',
  dialogHability: true,
  filter: false,
  checkbox: true,
  sort: false,
  export: false,
  paginator: false,
  expandable: false,
  disabled: false,
  partialField: '',
  show: 'No existe items o no está autorizado para verlos',
  iconsOfActions: iconsOfActionsList,
  classValidation: (row: DispatchToCustomer) => {
    if (row.state == Constants.DISPATCH_STATUS_LIST.CANCELLED.value && row.dispatchTypeCode !== Constants.ExchangeConfig.RETURN) {
      return 'pending';
    }
    return '';
  },
  columns: [
    {
      title: 'N° de NV',
      name: 'saleNoteId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.saleNoteId
    },
    {
      title: 'N° de despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchId
    },
    {
      title: 'Distrito',
      name: 'dispatchDistrict',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchDistrict
    },
    {
      title: 'Zona de despacho',
      name: 'dispatchZone',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchZone
    },
    {
      title: 'Entidad',
      name: 'currentEntityName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.currentEntityName
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.deliveryDate
    },
    {
      title: 'Estado NV',
      name: 'state',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => validateState(element.state)
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchTypeCode
    }
  ]
};
const dispatchSelectedResp = {
  searchText: '',
  dialogHability: true,
  filter: false,
  checkbox: true,
  sort: false,
  export: false,
  paginator: false,
  expandable: false,
  disabled: false,
  partialField: '',
  show: 'No existe items o no está autorizado para verlos',
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: DispatchToCustomer) => {
    return row.state == Constants.DISPATCH_STATUS_LIST.CANCELLED.value;
  },
  classValidation: (row: DispatchToCustomer) => {
    if (row.state == Constants.DISPATCH_STATUS_LIST.CANCELLED.value) {
      return 'pending';
    }
    return '';
  },
  columns: [
    {
      title: 'N° de despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchId
    },
    {
      title: 'Distrito',
      name: 'dispatchDistrict',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchDistrict
    },
    {
      title: 'Zona de despacho',
      name: 'dispatchZone',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchZone
    },
    {
      title: 'Estado NV',
      name: 'state',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => validateState(element.state)
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchTypeCode
    },
  ]
};
export { dispatchSelected, dispatchSelectedResp };
